import React, { useState } from "react"
import { Container, Row, Col, CardBody, Card, Button, CardTitle  } from "reactstrap"
import HWAMap from "pages/WQ/Maps/HWAMap"
import RecordComplaint from "../RecordComplaint"
import TrackComplaint from "../TrackComplaint"

const RoadMap = () => {
  const [step1, setStep1] = useState(true)
  const [step2, setStep2] = useState(false)
  const [complaintCategories, setComplaintCategories] = useState(['Leakage', 'Burst','Over-billing']);

  return (
    <React.Fragment>
      <section className="section bg-white" id="roadmap">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">

                <h4>Customer Complaints Tracking</h4>
              </div>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg="12">
              <div className="hori-timeline">
                <div
                  className="owl-carousel owl-theme  navs-carousel events"
                  id="timeline-carousel"
                >
                  {step1 ? (
                    <>
                      <Row>
                        <Col md={4}>
                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                           
                                <h5 className="mb-4">Raise Complaint</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  Specify Category of Complaint, Your Location, Account Number and Contact Details
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                    
                                <h5 className="mb-4">Submit Complaint</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                Submitted Complaint automatically Routed to relevant Authorities
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div
                            className="item event-list active"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                            
                                <h5 className="mb-4">Action Taken</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  Action Taken by those in charge, and Customer notified
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  {step2 ? (
                    <>
                      <Row>
                        <Col md={4}>
                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                          
                                <h5 className="mb-4">Customer Confirms</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  If Customer is satisfied, Complaint Closed For Future reference
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                              
                                <h5 className="mb-4">Track Complaint</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  With Complaint Tracking Number, Customer can check progress
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                          
                                <h5 className="mb-4">Recurring Complaints</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"/>
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  This Information can be used by Management to determine actions for long term solutions
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  <div className="owl-nav" style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      onClick={() => {
                        setStep1(true)
                        setStep2(false)
                      }}
                      className="border-0"
                      disabled={step1}
                    >
                      <i className="mdi mdi-chevron-left"/>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setStep1(false)
                        setStep2(true)
                      }}
                      className="border-0"
                      disabled={step2}
                    >
                      <i className="mdi mdi-chevron-right"/>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="text-center mb-5">
                     <p>&nbsp;</p> 
                <h4>Raise Complaint</h4>
              </div>
            </Col>
            <Col lg="6">
              <div className="text-center mb-5">
                     <p>&nbsp;</p> 
                <h4>Track Complaint</h4>
              </div>
            </Col>
          </Row>

          <Row>
          
            <Col lg="6">
              <RecordComplaint/>
            </Col>

            <Col lg="6">
              <TrackComplaint/>
                <Card>
                
                  <CardBody>
                  
                  <div className="text mb-5">
                       
                    <h6>Call Center Number: <strong>  52 8040/  52 8552 / 52 3226</strong></h6>
                    <h6>E-mail: <strong>  geckogorden1981@gmail.com</strong></h6>
                    <h6>Address: <br/><strong> Wadadaa 1 <sup>aad</sup> ee Wadnaha <br/> Kasoo horJeedka Madax-tooYada<br/>Hargeysa, Somaliland</strong></h6> 
                  </div>
                    <HWAMap/>
                  </CardBody>
                </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default RoadMap
